import { useQuery, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { deserializeProgrammation } from '@teetsh/app/src/containers/Programmations/atoms/serializer';
import { PROGRAMMATION_KEY } from '@teetsh/app/src/containers/Programmations/atoms/progAtoms';
import { ProgrammationView } from 'types/programmations';
import { progKeys } from './queryKeys';

export interface ProgrammationsFilters {
  matiereName?: string;
  view?: ProgrammationView;
}

export interface UseProgrammationsOptions {
  filters?: ProgrammationsFilters;
  enabled?: boolean;
}

function fetchProgrammations({
  schoolyearId,
  schoolId,
  filters,
}: {
  schoolyearId: string;
  schoolId: string;
  filters?: ProgrammationsFilters;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/programmations`;
  return request(requestURL, {
    method: 'GET',
    params: filters,
  }).then(({ data }: { data: any[] }) =>
    (data || []).map(p => deserializeProgrammation(p)),
  );
}

export function useProgrammations(options?: UseProgrammationsOptions) {
  const { filters, enabled = true } = options || {};
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: progKeys.list(
      schoolyear.id,
      school.id,
      filters ? JSON.stringify(filters) : undefined,
    ),
    queryFn: () =>
      fetchProgrammations({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        filters,
      }).then(programmations => {
        programmations.forEach(p => {
          queryClient.setQueryData(
            [schoolyear.id, school.id, PROGRAMMATION_KEY, p.id],
            p,
          );
        });
        return programmations;
      }),
    enabled,
    refetchOnWindowFocus: false,
  });
}
